export const numberToWords = (amount) => {
  const ones = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const convert = (n) => {
    if (n < 20) return ones[n];
    if (n < 100)
      return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    if (n < 1000)
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + convert(n % 100) : "")
      );
    for (const [value, label] of [
      [1e9, "Billion"],
      [1e6, "Million"],
      [1e3, "Thousand"],
    ]) {
      if (n >= value)
        return (
          convert(Math.floor(n / value)) +
          " " +
          label +
          (n % value ? " " + convert(n % value) : "")
        );
    }
    return "";
  };

  const centsTotal = Math.round(Number(amount) * 100);
  if (!Number.isSafeInteger(centsTotal) || centsTotal < 0) return "";

  const birr = Math.floor(centsTotal / 100);
  const cents = centsTotal % 100;

  return `${convert(birr)} Birr${
    cents ? " and " + convert(cents) + " Cents" : ""
  } Only`;
};
